import * as THREE from 'three';
let PERSPECTIVE = true;
let TRACE_MESSAGES = true;

document.addEventListener("mousemove", function (e) {
    window.mouseX = e.pageX;
    window.mouseY = e.pageY;
});


export function Connexion3DGL(inViewer, pointCloud) {
    this.gl = {};
    this.model = pointCloud;
    this.axes = null;
    this.viewer3DInstance = inViewer;
    this.animating = false;
    this.container3D = inViewer.renderArea
    this.camera = inViewer.scene.getActiveCamera();
    this.scene = inViewer.scene.scene;
    this.renderer = inViewer.renderer;
    this.defaultModel = new THREE.Mesh(new THREE.BoxGeometry(1, 1, 1), new THREE.MeshBasicMaterial({ color: 0xff0000 }));
    this.defaultModel.visible = false;

    this.initGL = function () { // Done
        var self = this;
        try {
            this.container3D.addEventListener("mousedown", function (e) {
                document.getElementById("potree_render_area")?.focus()
            });
            self.camera.position.set(10, 10, 10)
            self.container3D.tabIndex = "0"; // make the container focusable
            self.container3D.focus();
            self.gl.viewportWidth = self.container3D.clientWidth;
            self.gl.viewportHeight = self.container3D.clientHeight;
            self.gl.fov = self.camera.fov; // vertical fov
            self.gl.frustumNear = self.camera.near;
            self.gl.frustumFar = self.camera.far;

            self.scene.add(self.defaultModel)
            self.model = self.defaultModel;

        } catch (e) {
            // do nothing
        }
        if (!this.renderer) {
            alert('Could not initialize WebGL, sorry :-(');
        }
    };
    this.webGLStart = function () {

        var self = this;

        self.initGL();

        self.axes = new THREE.AxesHelper(10000.);
        self.scene.add(self.axes);
        self.camera.updateProjectionMatrix();
        // draw
        // initialize the 3d mouse
        // self.addRandomPlane();
        self.init3DMouse();
        self.renderer.render(self.scene, self.camera);

    };

    this.addRandomPlane = function () {
        this.model = new THREE.Object3D();
        this.scene.add(this.model);
        let noOfPlanes = 1000;
        for (let i = 0; i < noOfPlanes; i++) {
            let planeGeometry = new THREE.PlaneGeometry(1, 1, 1, 1);
            let planeMaterial = new THREE.MeshBasicMaterial({ color: 0x00ff00, side: THREE.DoubleSide });
            let plane = new THREE.Mesh(planeGeometry, planeMaterial);
            let bounds = 10000
            // Position the plane randoml in box of bounds x bounds x bounds
            plane.position.x = Math.random() * bounds - bounds / 2;
            plane.position.y = Math.random() * bounds - bounds / 2;
            plane.position.z = Math.random() * bounds - bounds / 2;

            // Random scale between 10 to 50
            let minScale = 10;
            let maxScale = 100;
            let scale = Math.random() * (maxScale - minScale) + minScale;
            plane.scale.set(scale, scale, scale);

            this.model.add(plane);
        }
        // //ox3 {min: Vector3, max: Vector3, isBox3: true}max: Vector3 {x: 7218163, y: 3264366, z: 20001, isVector3: true}min: Vector3 {x: 4796365, y: 1772619, z: -10001, isVector3: true}isBox3: true[[Prototype]]: Object
        // let box = new THREE.Box3(new THREE.Vector3(4796365, 1772619, -10001), new THREE.Vector3(7218163, 3264366, 20001));

        // let plane = new THREE.PlaneGeometry(100000, 100000, 1, 1);
        // let material1 = new THREE.MeshBasicMaterial({ color: 0x00ff00, side: THREE.DoubleSide });
        // let planeMesh = new THREE.Mesh(plane, material1);
        // planeMesh.position.copy(box.getCenter(new THREE.Vector3()))
        // planeMesh.position.z = 0;
        // planeMesh.position.y = 0;
        // planeMesh.position.x = 0;
        // this.model.add(planeMesh);
    }


    // the callback that results in the scene being rendered
    this.render = function (time) {
        var self = this;
        if (self.animating) {
            // Initiate a new frame transaction by updating the controller with the frame time.
            self._3Dconnexion.update3dcontroller({
                'frame': { 'time': time }
            });
            // Request an animation frame for the next incoming transaction data.
            window.requestAnimationFrame(self.render.bind(self));
        }

        // Render the current scene.
        self.renderer.render(self.scene, self.camera);
    };



    // getPivotPosition is called when the navlib needs to know where the application's rotation pivot is located
    // in this example we return the center of the geometry's bounding box
    this.getPivotPosition = function () {
        var volumeCenter = new THREE.Vector3();
        volumeCenter.addVectors(this.model.geometry.boundingBox.min, this.model.geometry.boundingBox.max);
        volumeCenter.divideScalar(2.);
        if (TRACE_MESSAGES)
            console.log('pivot=[' + volumeCenter.x + ', ' + volumeCenter.y + ', ' + volumeCenter.z + ']');
        return volumeCenter.toArray();
    };

    // getViewMatrix is called when the navlib requests the view matrix
    this.getViewMatrix = function () {
        // THREE.js matrices are column major (same as openGL)
        return this.camera.matrixWorld.toArray();
    };

    ///////////////////////////////////////////////////////////////////////////////////////////
    // Hit test properties
    // these are used by getLookAt and set by the 3dconnexion navlib
    this.look = {
        origin: new THREE.Vector3()
        , direction: new THREE.Vector3()
        , aperture: 0.01
        , selection: false
    };

    this.setLookFrom = function (data) {
        this.look.origin.set(data[0], data[1], data[2]);
    };

    this.setLookDirection = function (data) {
        this.look.direction.set(data[0], data[1], data[2]);
    };

    this.setLookAperture = function (data) {
        this.look.aperture = data;
    };

    this.setSelectionOnly = function (data) {
        this.look.selection = data;
    };

    // setViewMatrix is called when the navlib sets the view matrix
    this.setViewMatrix = function (data) {
        console.log('setViewMatrix');
        // console.log(this.camera)
        // Note data is a column major matrix
        var cameraMatrix = new THREE.Matrix4();

        cameraMatrix.fromArray(data);
        // console.log(this.camera)
        let pos = new THREE.Vector3();
        let rotation = new THREE.Quaternion();
        // update the camera
        cameraMatrix.decompose(pos, rotation, this.camera.scale);

        let yaw = new THREE.Euler().setFromQuaternion(rotation, 'YXZ').y;
        let pitch = new THREE.Euler().setFromQuaternion(rotation, 'YXZ').x;

        let lookAt = new THREE.Vector3(0, 0, -1).applyEuler(new THREE.Euler(pitch, yaw, 0, 'YXZ')).add(pos);

        potreeViewer.scene.view.setView(
            [pos.x, pos.y, pos.z],
            [lookAt.x, lookAt.y, lookAt.z]
        )

        let cameraPos = pos.clone()
        this.model.position.copy(cameraPos.setZ(window.globalZ))


        // potreeViewer.scene.view.position.copy(pos);
        console.log(this.camera.position)
        this.camera.updateMatrixWorld(true);
        this.renderer.render(this.scene, this.camera);
    };

    // onStartMotion is called when the 3DMouse starts sending data
    this.onStartMotion = function () {
        console.log('onStartMotion');
        var self = this;
        if (!self.animating) {
            self.animating = true;
            window.requestAnimationFrame(self.render.bind(self));
        }
    };

    // onStopMotion is called when the 3DMouse stops sending data
    this.onStopMotion = function () {
        this.animating = false;
    };

    ///////////////////////////////////////////////////////////////////////
    // the 3dconnexion 3DMouse initialization
    this.init3DMouse = function () {
        var self = this;
        self._3Dconnexion = new _3Dconnexion(self);
        if (!self._3Dconnexion.connect()) {
            if (TRACE_MESSAGES)
                console.log('Cannot connect to 3Dconnexion NL-Proxy');
        }
    };

    this.onConnect = function () {
        var self = this;
        // name is display to the user and used to identify the application
        // for the 3D mouse property panels.
        var name = 'WebThreeJS Sample';
        // we need to pass in a focusable object
        // we can use the <div /> if it has a tabindex
        var canvas = self.container3D

        self._3Dconnexion.create3dmouse(canvas, name);
    };

    this.on3dmouseCreated = function () {
        var self = this;

        // set ourselves as the timing source for the animation frames
        self._3Dconnexion.update3dcontroller({
            'frame': { 'timingSource': 1 }
        });
    };


    ///////////////////////////////////////////////////////////////////////
    this.getCoordinateSystem = function () {
        // In this sample the cs has X to the right, Y-up, and Z out of the screen
        // return [1, 0, 0, 0, 0, 1, 0, 0, 0, 0, 1, 0, 0, 0, 0, 1];
        // // The following would be for X to the right, Z-up, Y into the screen
        return [1, 0, 0, 0, 0, 0, -1, 0, 0, 1, 0, 0, 0, 0, 0, 1];
    };

    // getUnitsToMeters is queried to determine the conversion factor between model or world
    // units and the physical unit meters.
    this.getUnitsToMeters = function () {
        // 1 unit is 10m
        return 10.0;
    };

    // getFov is called when the navlib requests the fov
    // in three.js the fov is in degrees, the 3dconnexion lib uses radians
    // in three.js the fov is the vertical fov.
    // In this example we return the diagonal fov
    this.getFov = function () {
        var fov = 2. * Math.atan(Math.tan2(this.camera.fov * Math.PI, 360.) * Math.sqrt(1 + this.camera.aspect * this.camera.aspect));
        if (TRACE_MESSAGES)
            console.log('fov=' + (fov * 180. / Math.PI));
        return fov;
    };

    // getPerspective is called when the navlib needs to know the projection
    this.getPerspective = function () {
        return PERSPECTIVE;
    };

    // getModelExtents is called when the navlib requests the bounding box
    // of the model
    this.getModelExtents = function () {
        let boundingBox = new THREE.Box3().setFromObject(this.model);
        return [boundingBox.min.x, boundingBox.min.y, boundingBox.min.z, boundingBox.max.x, boundingBox.max.y, boundingBox.max.z];
    };



    // update the scene after a change
    this.updateScene = function () {
        // if we are not animating request an animation frame
        // otherwise do nothing as the scene will be redrawn in the animation loop
        var self = this;
        if (!self.animating) {
            window.requestAnimationFrame(self.render.bind(self));
        }
    };

    // setTransaction is called twice per frame
    // transaction >0 at the beginning of a frame change
    // transaction ===0 at the end of a frame change
    this.setTransaction = function (transaction) {
        if (transaction === 0) {
            // request a redraw if not animating
            this.updateScene();
        }
    };
}